<template>
  <a
    v-if="fields && fields.link"
    class="c-header-utility__link"
    :class="fields.link.value.class"
    :href="fields.link.value.href"
    :target="fields.link.value.target || ''"
    :title="fields.link.value.title || ''"
    v-html="fields.link.value.text"
  />
</template>

<script>
export default {
  name: 'CIS-HeaderUtility-Link',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.c-header-utility {
  &__link {
    @include font-styles('Arial Narrow', 2rem, 400, normal, normal, 0, $gray);
    text-decoration: none;
    padding-right: 2.5rem;
    position: relative;
    display: table;
    margin-bottom: 2rem;

    @include desktop-up {
      display: block;
      font-size: 1.6rem;
      line-height: 2rem;
      padding-right: 2rem;
      margin-left: 2.5rem;
      margin-bottom: 0;
    }

    @include exlarge-desktop-up {
      font-size: 1.7rem;
    }

    &::after {
      content: '';
      display: inline-block;
      background-size: contain;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      position: absolute;
    }
  }

  &__security {
    &::after {
      width: 1.6rem;
      height: 1.6rem;
      background-image: url(~@/assets/images/icon-security.svg);
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  &__support {
    &::after {
      width: 1.6rem;
      height: 1.6rem;
      background-image: url(~@/assets/images/icon-support.svg);
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  &__signin {
    padding-right: 2rem;

    @include desktop-up {
      padding-right: 1.5rem;
    }

    &::after {
      width: 1rem;
      height: 1.4rem;
      background-image: url(~@/assets/images/icon-login.svg);
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
}
</style>
